// TomSelect a richiesta: lo usa solo il pannello della ricerca avanzata.

let tomSelectPromise = null;

window.loadTomSelect = function () {
    if (!tomSelectPromise) {
        tomSelectPromise = Promise.all([
            import("tom-select"),
            import("tom-select/dist/css/tom-select.bootstrap5.min.css"),
        ]).then(([module]) => {
            const TomSelect = module.default ?? module;
            window.TomSelect = TomSelect;
            return TomSelect;
        });
    }

    return tomSelectPromise;
};
